'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isExternalLink"];
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import useSettledUrl from '../../hooks/useSettledUrl';
import UsageTrackerPublic from '../../utils/UsageTrackerPublic';
import { getAchievementUrlSlug } from '../../utils/urls';
import { usePublicAchievement, SingleCertAchievement, getMetadataLanguageFallback } from '../../features/achievement';
import { useRouteMatch } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const PublicAchievementContainer = () => {
  const match = useRouteMatch('/achievements/:publicId/:language/:template/:slug+');
  const {
    language,
    publicId,
    slug
  } = match.params;
  const {
    publicAchievement
  } = usePublicAchievement(publicId, language);
  const trackName = publicAchievement ? getMetadataLanguageFallback(publicAchievement.tracks[0].metadata, language).name : undefined;
  const urlSlug = publicAchievement && trackName ? getAchievementUrlSlug({
    firstName: publicAchievement.firstName,
    lastName: publicAchievement.lastName,
    trackName
  }) : undefined;
  useSettledUrl({
    actualSlug: slug,
    urlSlug
  });

  // TODO: Re-think tracking to avoid constantly prop drilling trackEvent
  const trackEvent = useCallback(_ref => {
    let {
        isExternalLink
      } = _ref,
      extra = _objectWithoutPropertiesLoose(_ref, _excluded);
    return UsageTrackerPublic[isExternalLink ? 'trackExternalLink' : 'track']('publicAchievementInteraction', Object.assign({
      publicId,
      language,
      template: 'SINGLE_CERT'
    }, extra));
  }, [language, publicId]);
  return /*#__PURE__*/_jsx(SingleCertAchievement, {
    language: language,
    publicId: publicId,
    trackEvent: trackEvent
  });
};
PublicAchievementContainer.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      publicId: PropTypes.string.isRequired,
      language: PropTypes.string.isRequired,
      actualSlug: PropTypes.string
    }).isRequired
  }).isRequired
};
export default PublicAchievementContainer;